import * as React from 'react';
import * as autobind from 'react-autobind';
import CommentScrollingService from '../../utils/CommentScroller';
import BasicCommentContainer from '../BasicComment/BasicCommentContainer';
import CommentModel from '../../types/CommentModel';

export default class Reply extends React.Component<ReplyProps, {}> {
   commentRef: HTMLElement;

   constructor(props: ReplyProps) {
      super(props);
      autobind(this);
   }

   componentDidMount() {
      const {selectedComment, reply} = this.props;

      if (selectedComment && selectedComment.id === reply.id) {
         CommentScrollingService.scrollCommentIntoView(this.commentRef, {alignment: 'center'});
      }
   }

   setRef(ref: HTMLElement) {
      this.commentRef = ref;
   }

   render() {
      const {reply, isEditable, onSelect} = this.props;

      return (
         <div className="reply-container" ref={this.setRef}>
            <BasicCommentContainer
               comment={reply}
               isEditable={isEditable}
               alternateDisplayText={null}
               deleteAnnotationOnSave={false}
               onCancelEdit={(): void => null}
               onReplyClick={(): void => null}
               onSaveEdit={(): void => null}
               onSelect={() => onSelect()}
               onEditClick={(): void => null}/>
         </div>
      );
   }
}

export interface ReplyProps {
   reply: CommentModel;
   isEditable: boolean;
   selectedComment: CommentModel;
   onSelect(): void;
}
